import { PdfChallenge, Score, TeamReference } from "@/models/pdfData";

export const scoreEquals = (score1?: Score, score2?: Score): boolean =>
  JSON.stringify(score1) === JSON.stringify(score2);

export const getSetFromScore = (setScore: Score) =>
  setScore.team1 + setScore.team2 + 1;

export const formatScore = (score: Score, team?: PdfChallenge["team"]) => {
  const pad = (score: number): string => score.toString().padStart(2, "0");
  const scoreTeam1 = score?.team1 || 0;
  const scoreTeam2 = score?.team2 || 0;
  const scoreParts = [pad(scoreTeam1), ":", pad(scoreTeam2)];
  if (team === "team2") {
    return scoreParts.reverse().join(" ");
  } else {
    return scoreParts.join(" ");
  }
};
